module.exports = new __parcel__URL__("tm5--dataset-cover.aeb9c149.jpg").toString();